import React from 'react';

import BigBanner from '../BigBanner/BigBanner';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

import './Modules.scss';

const ModuleHeroBanner = ({
  home,
  secondaryColor,
  sliderCircleArrowsBanner,
  sliderNavigationDots,
  heroBannerVersion,
  isMobile,
  datiFarmacia,
}) => {
  const renderHeroBanner = () => {
    if (isMobile) {
      return renderHeroBannerMobile();
    } else {
      return renderHeroBannerDesktop();
    }
  };

  const renderHeroBannerDesktop = () => {
    return (
      <div className="hidden-mobile">
        <BigBanner
          home={home}
          secondaryColor={secondaryColor}
          sliderCircleArrowsBanner={sliderCircleArrowsBanner}
          sliderNavigationDots={sliderNavigationDots}
          heroBannerVersion={heroBannerVersion}
        />
      </div>
    );
  };

  const renderHeroBannerMobile = () => {
    const {
      sliderTopSlide1Image: slide1Image,
      sliderTopSlide1Link: slide1Link,
      sliderTopSlide1SeoName: slide1SeoName,
      sliderTopSlide2Image: slide2Image,
      sliderTopSlide2Link: slide2Link,
      sliderTopSlide2SeoName: slide2SeoName,
      sliderTopSlide3Image: slide3Image,
      sliderTopSlide3Link: slide3Link,
      sliderTopSlide3SeoName: slide3SeoName,
      sliderTopSlide4Image: slide4Image,
      sliderTopSlide4Link: slide4Link,
      sliderTopSlide4SeoName: slide4SeoName,
      sliderTopSlide5Image: slide5Image,
      sliderTopSlide5Link: slide5Link,
      sliderTopSlide5SeoName: slide5SeoName,
      sliderTopSlide6Image: slide6Image,
      sliderTopSlide6Link: slide6Link,
      sliderTopSlide6SeoName: slide6SeoName,
    } = home;
    const slides = [
      { link: slide1Link, image: slide1Image, seoName: slide1SeoName },
      { link: slide2Link, image: slide2Image, seoName: slide2SeoName },
      { link: slide3Link, image: slide3Image, seoName: slide3SeoName },
      { link: slide4Link, image: slide4Image, seoName: slide4SeoName },
      { link: slide5Link, image: slide5Image, seoName: slide5SeoName },
      { link: slide6Link, image: slide6Image, seoName: slide6SeoName },
    ].filter(slide => !!slide.image);
    const getLinkLabel = link =>
      link
        .split(datiFarmacia.siteUrl)
        .join('')
        .split('/')
        .filter(part => !!part)
        .map(part => part.split('-').join(' '))
        .join(' -');
    return (
      <div className="hidden-desktop">
        <div className="mobile-module-slider">
          {slides.map((slide, i) => {
            if (!!slide.link) {
              return (
                <a
                  key={`banner_${i}_${slide.seoName}`}
                  href={slide.link}
                  aria-label={'Vai alla pagina ' + getLinkLabel(slide.link)}
                >
                  <ImageDispatcher
                    className={`module-slider-image ${
                      i >= 1 ? 'lazyload' : ''
                    }`}
                    src={slide.image}
                    alt={slide.seoName}
                    style={slides.length <= 1 ? { width: '100vw' } : {}}
                  />
                </a>
              );
            } else {
              return (
                <ImageDispatcher
                  key={`banner_${i}_${slide.seoName}`}
                  className={`module-slider-image ${i > 0 ? 'lazyload' : ''}`}
                  src={slide.image}
                  alt={slide.seoName}
                  style={slides.length <= 1 ? { width: '100vw' } : {}}
                />
              );
            }
          })}
        </div>
      </div>
    );
  };

  return <>{renderHeroBanner()}</>;
};

export default ModuleHeroBanner;
